import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import * as tableData from './smart-data-table';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'app-smart-data-listing',
  templateUrl: './smart-data-listing.component.html',
  styleUrls: ['./smart-data-listing.component.css']
})
export class SmartDataListingComponent implements OnInit {
  
  @Input("data")        data     : any   = [];
  source: LocalDataSource;
  settings = tableData.settings;

  constructor() {
    this.source = new LocalDataSource(this.data); // create the source
  }

  ngOnInit(): void {
  }

  doInit() {
    this.source.refresh();
  }
  
  ngAfterViewInit() {
    this.doInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['data']) {
      this.doInit();  
    }
  }

  onConfirmDelete($event : any) {
    $event.confirm.resolve();
  }

  onCreated($event) {
    
  }
  onEdited($event) {

  }
  onDeleted($event) {

  }

}
